// This component allows users to switch between different versions of the piece
import React, { useState } from 'react';
import '../styles/togglebutton.css';

const ToggleButton = ({
  numbers = [14, 42, 56],
  renderNumber,
  setRenderNumber,
  sync_flag,
}) => {
  return (
    <div className="toggle-wrapper">
      <div className="v-label">v</div>
      <div className="toggle-container-wrap">
        <div className="toggle-container">
          {numbers.map((number, index) => (
            <div
              key={index}
              className={`label ${number === renderNumber ? 'active' : ''}`}
              onClick={() => {
                setRenderNumber(number);
              }}
            >
              {number}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ToggleButton;
